var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-type"},[_c('kdx-form-title',{attrs:{"content":"商品类型"}}),_c('FormItem',{attrs:{"label":"","prop":"type"}},[_c('multi-select',{model:{value:(_vm.model_type),callback:function ($$v) {_vm.model_type=$$v},expression:"model_type"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }